<template>
  <r-panel :title="title" :button_add="true" @click_add="click_add">
    <r-reminder-table ref="table" :items.sync="value.items" :toolbar="false" :title="title"/>
  </r-panel>
</template>

<script>

import VueTypes from "vue-types";
import {ReminderBunch} from "@/modules/redactor/models/reminder/ReminderBunch";

import RPanel from "@/modules/redactor/views/utils/r-panel";
import RReminderTable from "@/modules/redactor/views/reminder/r-reminder-table.vue";

export default {
  name: "r-reminder-panel",
  components: {RReminderTable, RPanel},
  props: {
    title: VueTypes.string.def("Reminders"),
    model: VueTypes.instanceOf(ReminderBunch)
  },
  computed: {
    value() {
      if (this.model) {
        return this.model
      } else {
        let value = new ReminderBunch();
        this.$emit("update:model", value);
        return value;
      }
    }
  },
  methods: {
    click_add() {
      this.$refs["table"].row_create();
    }
  }
}

</script>